import { Injectable } from '@angular/core';
import { State } from '@app/core/models/state.model';

@Injectable()
export class StateService {
  list(): Array<State.FormPayload> {
    return [
      { id: 'AC', name: 'Acre' },
      { id: 'AL', name: 'Alagoas' },
      { id: 'AP', name: 'Amapá' },
      { id: 'AM', name: 'Amazonas' },
      { id: 'BA', name: 'Bahia' },
      { id: 'CE', name: 'Ceará' },
      { id: 'DF', name: 'Distrito Federal' },
      { id: 'ES', name: 'Espírito Santo' },
      { id: 'GO', name: 'Goiás' },
      { id: 'MA', name: 'Maranhão' },
      { id: 'MT', name: 'Mato Grosso' },
      { id: 'MS', name: 'Mato Grosso do Sul' },
      { id: 'MG', name: 'Minas Gerais' },
      { id: 'PA', name: 'Pará' },
      { id: 'PB', name: 'Paraíba' },
      { id: 'PR', name: 'Paraná' },
      { id: 'PE', name: 'Pernambuco' },
      { id: 'PI', name: 'Piauí' },
      { id: 'RJ', name: 'Rio de Janeiro' },
      { id: 'RN', name: 'Rio Grande do Norte' },
      { id: 'RS', name: 'Rio Grande do Sul' },
      { id: 'RO', name: 'Rondônia' },
      { id: 'RR', name: 'Roraima' },
      { id: 'SC', name: 'Santa Catarina' },
      { id: 'SP', name: 'São Paulo' },
      { id: 'SE', name: 'Sergipe' },
      { id: 'TO', name: 'Tocantins' }
    ];
  }
}
